const ErrorPageTemplate = ({code=404, title="Sorry we couldn't find this page. ", description=null, image=null})=>{
    return(
        <div class="flex items-center">
	<div class="container flex flex-col md:flex-row items-center justify-center px-5 text-gray-700">
   		<div class="max-w-md">
      		<div class="text-5xl font-dark font-bold">{code}</div>
            {title!=null && <p
              class="text-2xl md:text-3xl font-light leading-normal"
            >{title}</p>}
          {description!=null && <p class="mb-8">{description}</p>}
        </div>
      {image !=null && <div class="max-w-lg">{image}</div>}
    
  </div>
</div>
    )
}

export default ErrorPageTemplate;